import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingDetailsAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-details/src/helpCenterSettingDetailsAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { csmHubSetupResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceDetailsRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceDetailsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceDetailsPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceDetailsRouteEntry: Route = createEntry(csmExperienceDetailsRoute, () => ({
	group: 'helpcenter-settings',
	perfMetricKey: 'help-center-settings.csm-experience-details',
	layout: layoutWithCondition(
		() => fg('csm-support-widget-in-csm'),
		composeLayouts(serviceProjectLayout, csmWidgetLayout),
		serviceProjectLayout,
	),
	navigation: {
		sidebarId: SidebarIdCsmApp,
	},
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmExperienceDetailsPageEntryPoint
			: notFoundPageEntrypoint;
	},
	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getCsmExperiencesResources(),
		csmHubSetupResource,
	],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
